import gql from 'graphql-tag';

export const _GET_ACTIONS = gql`
	query actionsGet(
		$limit: Int = 10
		$offset: Int = 0
		$status: [risolto_action_status_enum!]
		$execution_type: [risolto_action_execution_type_enum!]
		$participant: uuid!
		$invoice: uuid
		$channel: risolto_channel_enum
		$recipientRef: uuid
		$orderBy: [risolto_action_order_by!]
	) {
		total: risolto_action_aggregate(
			order_by: $orderBy
			where: {
				participant: { _eq: $participant }
				recipient: { _eq: $recipientRef }
				status: { _in: $status }
				execution_type: { _in: $execution_type }
				channel: { _eq: $channel }
			}
		) {
			aggregate {
				count
			}
		}
		actions: risolto_action(
			order_by: { updated_at: desc }
			limit: $limit
			offset: $offset
			where: {
				participant: { _eq: $participant }
				recipient: { _eq: $recipientRef }
				status: { _in: $status }
				execution_type: { _in: $execution_type }
				channel: { _eq: $channel }
			}
		) {
			reference
			metadata
			message_code
			participant
			action_invoices {
				reference
				relation
				invoice_by_reference {
					invoice_number
					open_amount
					total_amount
					payment_reference
					due_date
					issue_date
					status
					recipient
					recipient_by_reference {
						reference
						name
					}
					legal_entity
					legal_entity_by_reference {
						reference
						registration_name
					}
					participant
					participant_by_reference {
						name
						reference
						logical_id
					}
					reference
					amount_currency
					interchange_links {
						interchange_by_reference {
							reference
							channel
							direction
						}
					}
				}
			}
			legal_entity
			execution_type
			status
			channel
			source
			executed_at
			original_action
			retry_count
			start_time
			due_date
			recipient
			recipient_by_reference {
				reference
				name
				account_id
				custom_fields
			}
			legal_entity_by_reference {
				registration_name
			}
			created_at
			assignee
			assignee_by_reference {
				username
			}
		}
	}
`;

export const _GET_INVOICE_ACTIONS = gql`
	query actionsGetInvoiceActions(
		$limit: Int = 10
		$offset: Int = 0
		$status: [risolto_action_status_enum!]
		$execution_type: [risolto_action_execution_type_enum!]
		$participant: uuid!
		$invoice: uuid
		$channel: risolto_channel_enum
		$recipientRef: uuid
		$orderBy: [risolto_action_order_by!]
	) {
		total: risolto_action_aggregate(
			where: {
				participant: { _eq: $participant }
				action_invoices: { invoice_by_reference: { reference: { _eq: $invoice } } }
				recipient: { _eq: $recipientRef }
				status: { _in: $status }
				execution_type: { _in: $execution_type }
				channel: { _eq: $channel }
			}
		) {
			aggregate {
				count
			}
		}
		actions: risolto_action(
			order_by: { updated_at: desc }
			limit: $limit
			offset: $offset
			where: {
				participant: { _eq: $participant }
				action_invoices: { invoice_by_reference: { reference: { _eq: $invoice } } }
				recipient: { _eq: $recipientRef }
				status: { _in: $status }
				execution_type: { _in: $execution_type }
				channel: { _eq: $channel }
			}
		) {
			reference
			metadata
			message_code
			participant
			action_invoices {
				invoice
				relation
				invoice_by_reference {
					invoice_number
					open_amount
					total_amount
					payment_reference
					due_date
					issue_date
					status
					recipient
					recipient_by_reference {
						reference
						name
					}
					legal_entity
					legal_entity_by_reference {
						reference
						registration_name
					}
					participant
					participant_by_reference {
						name
						reference
						logical_id
					}
					reference
					amount_currency
					interchange_links {
						interchange_by_reference {
							reference
							channel
							direction
						}
					}
				}
			}
			legal_entity
			execution_type
			status
			channel
			source
			original_action
			retry_count
			executed_at
			start_time
			due_date
			recipient
			recipient_by_reference {
				reference
				name
				account_id
			}
			legal_entity_by_reference {
				registration_name
			}
			created_at
			assignee
			assignee_by_reference {
				username
			}
		}
	}
`;

export const _GET_PARTICIPANT_ACTION_AGGREGATE = gql`
	query actionsGetParticipantActionAggregate ($actionType: [risolto_action_execution_type_enum!], $status: [risolto_action_status_enum!]) {
		risolto_action_aggregate(where: { execution_type: { _in: $actionType }, status: { _in: $status } }) {
			aggregate {
				count
			}
		}
	}
`;

export const _GET_ACTION = gql`
	query actionsGetAction ($action: uuid!, $participant: uuid!) {
		action: risolto_action(where: { reference: { _eq: $action }, participant: { _eq: $participant } }) {
			reference
			metadata
			channel
			message_code
			participant
			participant_by_reference {
				name
			}
			legal_entity
			legal_entity_by_reference {
				company_id
				company_id_type
				registration_name
				outbound_channel: processing_details(path: "outbound_channel")
			}
			recipient
			recipient_by_reference {
				reference
				account_id
			}
			execution_type
			status
			source
			due_date
			original_action
			retry_count
			created_at
			assignee
			assignee_by_reference {
				username
			}
			channel_endpoint
			channel_endpoint_by_reference {
				channel
				endpoint
				endpoint_details
				deactivated_at
				deactivated_by
				last_failed_delivery_at
				last_failed_delivery_type
				locale
				priority
			}
		}
	}
`;

export const _UPDATE_ACTION_ASSIGNEE = gql`
	mutation actionsUpdateActionAssignee ($actionRef: uuid!, $personRef: uuid) {
		update_risolto_action(where: { reference: { _eq: $actionRef } }, _set: { assignee: $personRef }) {
			updated_count: affected_rows
			updated: returning {
				reference
				assignee_by_reference {
					username
				}
			}
		}
	}
`;

export const _UPDATE_ACTION_METADATA = gql`
mutation actionsUpdateActionMetadata (
	$action: uuid!
	$metadata: jsonb!
	$channel: risolto_channel_enum!
  ) {
	update_risolto_action(
	  where: { 
		reference: { _eq: $action } 
	  }, 
	  _set: { 
	  metadata: $metadata 
	  channel: $channel
	}) {
	  updated_count: affected_rows
	  updated: returning {
		reference
		metadata
	  }
	}
  }`;

export const _INSERT_ACTION = gql`
	mutation actionsAdd (
		$channel: risolto_channel_enum
		$executionType: risolto_action_execution_type_enum
		$legalEntity: uuid
		$recipient: uuid
		$metadata: jsonb
		$participant: uuid
		$status: risolto_action_status_enum
		$startTime: timestamptz
		$exectutedAt: timestamptz
		$source: risolto_action_source_enum
		$messageCode: String
		$primaryInvoice: uuid!
		$invoiceGroupInvoices:[risolto_invoice_group_invoice_insert_input!]!
	) {
		insert_risolto_action(
			objects: {
				channel: $channel
				execution_type: $executionType
				metadata: $metadata
				legal_entity: $legalEntity
				participant: $participant
				status: $status
				start_time: $startTime
				executed_at: $exectutedAt
				recipient: $recipient
				message_code: $messageCode
				source: $source
				primary_invoice: $primaryInvoice
                dunning_notice_by_reference:{
                  data:{
                    participant:$participant
                    legal_entity:$legalEntity
                    recipient:$recipient
                    type_code: _100_REMINDER,
                    charges: 0,
                    principal_amount: 0,
                    interest: 0,
                    invoice_group_by_reference:{
                      data:{
                        participant:$participant
                        legal_entity:$legalEntity
                        recipient:$recipient
                        invoice_group_invoices:{
                          data:$invoiceGroupInvoices
                        }
                      }
                    }
                  }
                }
			}
		) {
			affected_rows
			returning {
				reference
			}
		}
	}
`;

export const _ACTION_DETAILS_FIELDS_FRAGMENT = gql`
	fragment actionsFragmentDetailsFields on risolto_action {
		status
		channel
		recipient
		recipient_by_reference {
			address
			balance_amount
			dunning_metadata
			last_dunning_at
			legal_id
			legal_id_type
			name
			account_id
			type
			updated_by
			participant
			reference
			legal_entity
			legal_entity_by_reference {
				reference
				registration_name
			}
		}
		reference
		metadata
		message_code
		participant
		primary_invoice
		primary_invoice_by_reference {
			invoice_number
		}
		action_invoices {
			reference
			relation
			invoice_by_reference {
				invoice_number
				open_amount
				total_amount
				payment_reference
				due_date
				issue_date
				status
				recipient
				recipient_by_reference {
					reference
					name
				}
				legal_entity
				legal_entity_by_reference {
					reference
					registration_name
				}
				participant
				participant_by_reference {
					name
					reference
					logical_id
				}
				reference
				amount_currency
				interchange_links {
					interchange_by_reference {
						reference
						channel
						direction
					}
				}
			}
		}
		legal_entity
		execution_type
		source
		executed_at
		original_action
		retry_count
		start_time
		due_date
		recipient
		recipient_by_reference {
			reference
			name
			account_id
			participant
		}
		legal_entity_by_reference {
			registration_name
			outbound_channel: processing_details(path: "outbound_channel")
		}
		created_at
		assignee
		assignee_by_reference {
			username
		}
		channel_endpoint
		channel_endpoint_by_reference {
			channel
			endpoint
			endpoint_details
			deactivated_at
			deactivated_by
			last_failed_delivery_at
			last_failed_delivery_type
			locale
			priority
		}
	}
`;

export const _INSERT_MANUAL_ACTION_INVOICE_COPY = gql`  
	mutation actionsAddManualActionInvoiceCopy(
		$participant: uuid!
		$legalEntity: uuid
		$recipient: uuid!
		$metadata: jsonb!
		$invoice: uuid!
		$channelEndpoint: uuid
		$start_time: timestamptz
	) {
		action: insert_risolto_action_one(
			object: {
				participant: $participant
				legal_entity: $legalEntity
				recipient: $recipient
				channel_endpoint: $channelEndpoint
				channel: EMAIL
				source: MANUAL
				status: OPEN
				metadata: $metadata
				primary_invoice: $invoice
				execution_type: MANUAL
				message_code: "invoiceCopy"
				start_time: $start_time
				action_invoices: {
					data: [{
						participant: $participant
						legal_entity: $legalEntity
						invoice: $invoice
						relation: "PRIMARY"
					}]
					on_conflict: {
						constraint: action_invoice_action_invoice_key
						update_columns: []
					}
				}
			}
		) {
			...actionsFragmentDetailsFields
		}
	}
	${_ACTION_DETAILS_FIELDS_FRAGMENT}
`;

export const _GET_SEND_INVOICE_COPY_DATA = gql`
query actionsGetSendInvoiceCopyData (
	$participant: uuid!
	$legalEntity: uuid!
	$recipient: uuid!
	$invoices: [uuid!]!
) {
	legal_entity: risolto_legal_entity(where: { reference: { _eq: $legalEntity } }) {
		communication: processing_details(path: "outbound_channel.communication")
	}
	recipient: risolto_recipient(where: { reference: { _eq: $recipient } }) {
		language_code
	}
	channel_endpoints: risolto_invoicing_channel_endpoints_v1(
		args: {
			q_participant: $participant
			q_legal_entity: $legalEntity
			q_recipient: $recipient
			q_channels: "{EMAIL}"
		}
		where: {
			channel_endpoint_by_reference: { deactivated_at: { _is_null: true } }
		}
		limit: 1
	) {
		channel_endpoint: channel_endpoint_by_reference {
			reference
			endpoint
			locale
		}
	}
	invoices: risolto_invoice_document(where: { reference: { _in: $invoices } }) {
		attachments: file_references
	}
}
`;

export const _GET_NEXT_ACTIONS_V2 = gql`
	query actionsGetNextActionsV2(
		$reference: uuid
		$participant: uuid!
		$recipient: uuid
		$limit: Int
		$offset: Int
		$channels: [risolto_channel_enum!]
		$statuses: [risolto_action_status_enum!]
		$searchTerm: String!
		$msgCode: String
		$invoices: [uuid!]
		$orderBy: [risolto_action_order_by!]
	) {
		total: risolto_action_aggregate(
			where: {
				_and: [
					{ _or: [{ primary_invoice: { _in: $invoices } }] }
					{
						_or: [
							{ message_code: { _ilike: $searchTerm } }
							{ recipient_by_reference: { name: { _ilike: $searchTerm } } }
							{ recipient_by_reference: { account_id: { _ilike: $searchTerm } } }
						]
					}
					{ channel: { _in: $channels } }
					{ participant: { _eq: $participant } }
					{ recipient: { _eq: $recipient } }
					{ status: { _in: $statuses } }
					{ message_code: { _eq: $msgCode } }
					{ reference: { _eq: $reference } }
				]
			}
			order_by: $orderBy
		) {
			aggregate {
				count
			}
		}
		risolto_action(
			where: {
				_and: [
					{ _or: [{ primary_invoice: { _in: $invoices } }] }
					{
						_or: [
							{ message_code: { _ilike: $searchTerm } }
							{ recipient_by_reference: { name: { _ilike: $searchTerm } } }
							{ recipient_by_reference: { account_id: { _ilike: $searchTerm } } }
						]
					}
					{ channel: { _in: $channels } }
					{ participant: { _eq: $participant } }
					{ recipient: { _eq: $recipient } }
					{ status: { _in: $statuses } }
					{ message_code: { _eq: $msgCode } }
					{ reference: { _eq: $reference } }
				]
			}
			order_by: $orderBy
			limit: $limit
			offset: $offset
		) {
			status
			channel
			recipient
			recipient_by_reference {
				address
				balance_amount
				dunning_metadata
				last_dunning_at
				legal_id
				legal_id_type
				name
				account_id
				type
				updated_by
				participant
				reference
				legal_entity
				legal_entity_by_reference {
					reference
					registration_name
				}
			}
			reference
			metadata
			message_code
			is_retry
			participant
			primary_invoice
			primary_invoice_by_reference {
				invoice_number
			}
			action_invoices {
				reference
				relation
				invoice_by_reference {
					invoice_number
					open_amount
					total_amount
					payment_reference
					due_date
					issue_date
					status
					recipient
					recipient_by_reference {
						reference
						name
					}
					legal_entity
					legal_entity_by_reference {
						reference
						registration_name
					}
					participant
					participant_by_reference {
						name
						reference
						logical_id
					}
					reference
					amount_currency
					interchange_links {
						interchange_by_reference {
							reference
							channel
							direction
						}
					}
				}
			}
			legal_entity
			execution_type
			source
			executed_at
			original_action
			retry_count
			start_time
			due_date
			recipient
			recipient_by_reference {
				reference
				name
				account_id
				participant
			}
			legal_entity_by_reference {
				registration_name
				outbound_channel: processing_details(path: "outbound_channel")
			}
			created_at
			assignee
			assignee_by_reference {
				username
			}
			channel_endpoint
			channel_endpoint_by_reference {
				channel
				endpoint
				endpoint_details
				deactivated_at
				deactivated_by
				last_failed_delivery_at
				last_failed_delivery_type
				locale
				priority
			}
		}
	}
`;

// ***
// DEPRECATED - TO BE FACTORED OUT
// ***
export const _GET_NEXT_ACTIONS = gql`
	query actionsGetNextActions(
		$participant: uuid!
		$recipient: uuid!
		$limit: Int
		$offset: Int
		$channels: [risolto_channel_enum!]
		$statuses: [risolto_action_status_enum!]
		$searchTerm: String!
	) {
		total: risolto_action_aggregate(
			where: {
				message_code: { _ilike: $searchTerm }
				channel: { _in: $channels }
				participant: { _eq: $participant }
				recipient: { _eq: $recipient }
				status: { _in: $statuses }
			}
			order_by: { start_time: asc_nulls_last }
		) {
			aggregate {
				count
			}
		}
		risolto_action(
			where: {
				message_code: { _ilike: $searchTerm }
				channel: { _in: $channels }
				participant: { _eq: $participant }
				recipient: { _eq: $recipient }
				status: { _in: $statuses }
			}
			order_by: { start_time: asc_nulls_last }
			limit: $limit
			offset: $offset
		) {
			status
			channel
			recipient
			recipient_by_reference {
				participant
				reference
				address
				balance_amount
				dunning_metadata
				last_dunning_at
				legal_id
				legal_id_type
				name
				type
				updated_by
				legal_entity
				legal_entity_by_reference {
					reference
					registration_name
				}
			}
			reference
			metadata
			message_code
			participant
			action_invoices {
				reference
				relation
				invoice_by_reference {
					invoice_number
					open_amount
					total_amount
					payment_reference
					due_date
					issue_date
					status
					recipient
					recipient_by_reference {
						reference
						name
					}
					legal_entity
					legal_entity_by_reference {
						reference
						registration_name
					}
					participant
					participant_by_reference {
						name
						reference
						logical_id
					}
					reference
					amount_currency
					interchange_links {
						interchange_by_reference {
							reference
							channel
							direction
						}
					}
				}
			}
			legal_entity
			execution_type
			source
			executed_at
			original_action
			retry_count
			start_time
			due_date
			recipient
			recipient_by_reference {
				name
				account_id
				reference
			}
			legal_entity_by_reference {
				registration_name
			}
			created_at
			assignee
			assignee_by_reference {
				username
			}
		}
	}
`;

gql`  
	mutation actionsAddInvoiceCopyMail (
		$participant: uuid!
		$legalEntity: uuid
		$recipient: uuid!
		$metadata: jsonb!
		$invoice: uuid!
		$channelEndpoint: uuid
		$start_time: timestamptz!
	) {
		action: insert_risolto_action_one(
			object: {
				participant: $participant
				legal_entity: $legalEntity
				recipient: $recipient
				channel_endpoint: $channelEndpoint
				channel: MAIL
				source: MANUAL
				status: OPEN
				metadata: $metadata
				primary_invoice: $invoice
				execution_type: MANUAL
				message_code: "Invoice Copy"
				start_time: $start_time
			}
		) {
			...actionsFragmentDetailsFields
		}
	}
	${_ACTION_DETAILS_FIELDS_FRAGMENT}
`;

gql`
	mutation actionsAddManualAction(
		$channel: risolto_channel_enum
		$status: risolto_action_status_enum
		$legalEntity: uuid
		$recipient: uuid
		$participant: uuid
		$startTime: timestamptz
		$assignee: uuid
		$metadata: jsonb,
		$primaryInvoice: uuid!
		$invoiceGroupInvoices:[risolto_invoice_group_invoice_insert_input!]!
	) {
		insert_risolto_action(
			objects: {
				participant: $participant
				legal_entity: $legalEntity
				recipient: $recipient
				execution_type: MANUAL
				status: $status
				source: MANUAL
				start_time: $startTime
				channel: $channel
				assignee: $assignee
				metadata: $metadata
				message_code: "scheduled manual action"
				primary_invoice: $primaryInvoice
                dunning_notice_by_reference:{
                  data:{
                    participant:$participant
                    legal_entity:$legalEntity
                    recipient:$recipient
                    type_code: _100_REMINDER,
                    charges: 0,
                    principal_amount: 0,
                    interest: 0,
                    invoice_group_by_reference:{
                      data:{
                        participant:$participant
                        legal_entity:$legalEntity
                        recipient:$recipient
                        invoice_group_invoices:{
                          data:$invoiceGroupInvoices
                        }
                      }
                    }
                  }
                }
			}
		) {
			affected_rows
			returning {
				reference
			}
		}
	}
`;

gql`
	query actionsGetSendInvoiceCopyMailData ($recipient: uuid!, $invoices: [uuid!]!) {
		recipient: risolto_recipient_by_pk(reference: $recipient) {
			reference
			name
			participant
			language_code
			legal_entity: legal_entity_by_reference {
				reference
				address: processing_details(path: "postal_address")
				default_postal_provider: processing_details(path: "outbound_channel.postal_provider")
				communication_postal_provider: processing_details(path:"outbound_channel.communication.postal_provider")
				communication_templates(
					where: {channel: {_eq: MAIL}, template_id: {_eq: "invoice_copy"}}
				) {
					template_id
				}
			}
			channel_endpoints(
				where: { channel: { _eq: "MAIL" }, deactivated_at: { _is_null: true } }
			) {
				reference
				address: endpoint_details
				contact: contact_by_reference {
					first_name
					last_name
				}
			}
			invoices: invoice_documents(where: { reference: { _in: $invoices } }) {
				attachments: file_references
			}
		}
	}
`;

gql`
	query actionsGetSendCreditNoteCopyMailData ($recipient: uuid!, $creditNotes: [uuid!]!) {
		recipient: risolto_recipient_by_pk(reference: $recipient) {
			reference
			name
			participant
			language_code
			legal_entity: legal_entity_by_reference {
				reference
				address: processing_details(path: "postal_address")
				default_postal_provider: processing_details(path: "outbound_channel.postal_provider")
				communication_postal_provider: processing_details(path:"outbound_channel.communication.postal_provider")
				communication_templates(
					where: {channel: {_eq: MAIL}, template_id: {_eq: "credit_note_copy"}}
				) {
					template_id
				}
			}
			channel_endpoints(
				where: { channel: { _eq: "MAIL" }, deactivated_at: { _is_null: true } }
			) {
				reference
				address: endpoint_details
				contact: contact_by_reference {
					first_name
					last_name
				}
			}
			credit_notes: credit_notes(where: { reference: { _in: $creditNotes } }) {
				attachments: file_references
			}
		}
	}
`;

gql`  
	mutation actionsAddCreditNoteCopyMail (
		$participant: uuid!
		$legalEntity: uuid
		$recipient: uuid!
		$metadata: jsonb!
		$creditNote: uuid!
		$channelEndpoint: uuid
		$start_time: timestamptz!
	) {
		action: insert_risolto_action_one(
			object: {
				participant: $participant
				legal_entity: $legalEntity
				recipient: $recipient
				channel_endpoint: $channelEndpoint
				channel: MAIL
				source: MANUAL
				status: OPEN
				metadata: $metadata
				credit_note: $creditNote
				execution_type: MANUAL
				message_code: "credit_note_copy"
				start_time: $start_time
			}
		) {
			...actionsFragmentDetailsFields
		}
	}
	${_ACTION_DETAILS_FIELDS_FRAGMENT}
`;

gql`
query actionsGetSendCreditNoteCopyData (
	$participant: uuid!
	$legalEntity: uuid!
	$recipient: uuid!
	$creditNotes: [uuid!]!
) {
	legal_entity: risolto_legal_entity(where: { reference: { _eq: $legalEntity } }) {
		communication: processing_details(path: "outbound_channel.communication")
	}
	channel_endpoints: risolto_invoicing_channel_endpoints_v1(
		args: {
			q_participant: $participant
			q_legal_entity: $legalEntity
			q_recipient: $recipient
			q_channels: "{EMAIL}"
		}
		where: {
			channel_endpoint_by_reference: { deactivated_at: { _is_null: true } }
		}
		limit: 1
	) {
		channel_endpoint: channel_endpoint_by_reference {
			reference
			endpoint
			locale
		}
	}
	credit_notes: risolto_credit_note(where: { reference: { _in: $creditNotes } }) {
		attachments: file_references
	}
}
`;

gql`  
	mutation actionsAddManualActionCreditNoteCopy(
		$participant: uuid!
		$legalEntity: uuid
		$recipient: uuid!
		$metadata: jsonb!
		$creditNote: uuid!
		$channelEndpoint: uuid
		$start_time: timestamptz
	) {
		action: insert_risolto_action_one(
			object: {
				participant: $participant
				legal_entity: $legalEntity
				recipient: $recipient
				channel_endpoint: $channelEndpoint
				channel: EMAIL
				source: MANUAL
				status: OPEN
				metadata: $metadata
				execution_type: MANUAL
				message_code: "credit_note_copy"
				start_time: $start_time
				credit_note: $creditNote
			}
		) {
			...actionsFragmentDetailsFields
		}
	}
	${_ACTION_DETAILS_FIELDS_FRAGMENT}
`;

gql`
	mutation actionsUpdateChannelEndpoint ($action: uuid!, $channelEndpoint: uuid!) {
		update_risolto_action(where: { reference: { _eq: $action } }, _set: { channel_endpoint: $channelEndpoint }) {
			updated_count: affected_rows
			updated: returning {
				reference
				channel_endpoint
			}
		}
	}
`;
